import { render, staticRenderFns } from "./ListQuestionAnswerCard.vue?vue&type=template&id=44f69496&scoped=true&"
import script from "./ListQuestionAnswerCard.vue?vue&type=script&lang=js&"
export * from "./ListQuestionAnswerCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tailwind.min.css?vue&type=style&index=0&id=44f69496&prod&scoped=true&lang=css&"
import style1 from "./ListQuestionAnswerCard.vue?vue&type=style&index=1&id=44f69496&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f69496",
  null
  
)

export default component.exports